import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-activity/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-activity/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-activity/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-activity/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-activity/detail',
    method: 'get',
    params: { id }
  })
}
export function putTop(params) {
  return request({
    url: '/cooking/cooking-activity/zd',
    method: 'get',
    params
  })
}
